import { css } from "@emotion/core"
import styled from "@emotion/styled"

const respMobile = '925px'

/*---------------- For Footer styled ----------------*/
export const FooterStyled = styled.footer`
    margin-top: 50px;
    color: #202020;
    font-size: 20px;
    
    background: #2a3746;
    box-shadow: inset 0 10px 10px -5px #0d1116;
    padding-bottom: 2em;

    section {
        max-width: 1080px;
        margin: 0 auto;
        padding: 0 20px;
    }
`;

export const Sitemap = styled.section`
    display: flex;
    flex-wrap: wrap;
    
    /* Supports Grid */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, auto));
    grid-gap: 1em;
    margin: 0 auto;
    padding: 0 20px;

    h5 {
        color: #869cb6;
        font-size: 22px;
    }
    
    a {
        color: white;
        display: table;
        margin: 2px -10px;
        padding: 3px 10px;
        &:hover {
            color: #f7a046;
        }
    }
`

/*--------------- For Category styled ---------------*/
export const CategoryPost = styled.div`
    display: flex;
    align-items: center;
    margin: 0 auto 12px auto;
    &:last-child {
        margin-bottom: 0;
    }
`

export const CategoryPostDescriptionImage = styled.img`
    
    @media screen and (max-width: ${respMobile}) {
        display: none;
    }
`

export const CategoryPostDescription = styled.div`
    flex: 1;
    margin-left: 18px;
    padding: 12px;
    @media screen and (max-width: ${respMobile}) {
        margin-left: 0;
    }
`

export const CategoryPostTitle = styled.h2`
    margin: 0 0 12px 0;
    padding: 0;
`

export const CategoryExcerpt = styled.div`
    margin: 0;
`

/*---------------------------------------------------*/

/*----------------- For Post styled -----------------*/

export const PostGeneral = styled.div`
    margin-bottom: 2.03125rem;
    &:last-child {
        margin-bottom: .8125rem;
    }
`

export const PostMetaDivider = styled.span`
    margin: 0 5px;
`

export const LinkCategory = css`
    font-size: .875rem;
    /*color: #f7a046;*/
    color: #874508;
    font-weight: 500;
    text-transform: uppercase;
    &:hover,
    &:focus {
        color: #874508;
        text-decoration: underline;
    }
`

export const PostTitle = styled.h2`
    font-size: 1.6875rem;
    line-height: 2.4375rem;
    margin-top: 0;
    margin-bottom: .8125rem;
`

export const PostExcerpt = styled.div`
    font-size: 1rem;
    line-height: 1.625rem;
    margin-bottom: 1.21875rem;
`
/*---------------------------------------------------*/


export const sPostLanguage = css`
    font-size: .875rem;
    /*color: red;*/
    color: #B30000;
    font-weight: 500;
    text-transform: uppercase;
    margin-right: 10px;
    &:hover,
    &:focus {
        color: #B30000;
        text-decoration: underline;
    }
`

export const sGoto = css `
    font-size: 1rem;
    /*color: #5d93ff;*/
    color: #0047E0;
    &:hover,
    &:focus {
        color: #0047E0;
        text-decoration: underline;
    }
`

export const sPostTitleLink = css`
    color: #222;
    &:hover,
    &:focus {
        color: #222;
        border-bottom: 1px solid #222;
    }
`

/*---------------- For Header styled ----------------*/
export const LienzoHeader = styled.div`
    height: 50px;
    background-color: FFFFFF;
    border-bottom: .1vmin solid #d3d3d3;
`

export const MainTitle = styled.h3`
    margin: 5px auto;
    padding: 5px 20px;
    color: #4a4a4a;
    text-align: center;

    @media screen and (max-width: ${respMobile}) {
        font-size: 23px;
        margin-top: 10px;
        margin-left: 36px;
        display: inline-block;
    }
`

export const LienzoMenu = styled.div`
    height: 40px;
    background-color: FFFFFF;
    border-bottom: .1vmin solid #d3d3d3;

    @media screen and (max-width: ${respMobile}) {
        display: none;
    }
`

export const Nav = styled.div`
    display: table;
    margin: 0 auto;
    text-align: center;
`

export const MenuUl = styled.ul`
    listStyle: none;
    display: inline-block;

    @media screen and (max-width: ${respMobile}) {
        list-style-type: none;
    }
`

export const MenuLi = styled.li`
    display: inline-block;
    margin-right: 1rem;

    @media screen and (max-width: ${respMobile}) {
        display: block;
        margin-right: 0rem;
    }
`

export const LinkMenu = css`
    text-decoration: none;
    color: #2a3746;
    &: hover {
        text-decoration: underline;
    }

    @media screen and (max-width: ${respMobile}) {
        display: block;
        text-align: center;
        padding: 14px 16px;
        display: block;
    
        &:hover {
            background-color: #2a3746;
            color: white;
        }
    }
`

export const MobileMenu = styled.div`
    display: none;

    @media screen and (max-width: ${respMobile}){
        display: block;
    }
`
/*---------------------------------------------------*/

/*---------------- For Layout styled ----------------*/

export const Children = styled.div`
    margin: 0 auto;
    max-width: 800px;
    padding: 1rem;
`

export const Declaration = styled.div`
    font-style: italic;
    text-align: center;
    padding: 0 1rem;

    @media screen and (max-width: ${respMobile}) {
        padding: 0;
    }
`
/*---------------------------------------------------*/

/*-------------- For Navigation styled --------------*/
export const SectionNav = styled.section`
    display: flex;
    flex-wrap: wrap;

    margin: 0 -20px;
    /* Supports Grid */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(275px, auto));;
`

export const MoveNavigation = styled.ul`
    float: left;

    li {
        display: inline-block;
        margin: 8px 0;
        margin-right: 1rem;
        font-weight: bold;

        a {
            color: #B30000;
            &:hover, 
            &:focus {
                text-decoration: underline;
            }
        }
    }    

`

export const ShowingPage = styled.ul`
    float: right;

    li {
        display: inline-block;
        margin: 8px 0;
        margin-right: 0.5rem;
    }
`

export const SelectPage = styled.select`
    background: transparent;
    border: none;
    padding: 5px;
    width: 50px;
    /*color: #d65947;*/
    color: #B30000;
    margin: auto 2px;
    font-weight:bold;

    &:focus { 
        outline: none;
    }
`
/*---------------------------------------------------*/

/*-------------- For Line Tags styled ---------------*/
export const LineTag = styled.ul`
    list-style: none;
    margin: 0 -5px;
    padding: 0;

    li {
        display: inline-block;
        margin: 10px 5px;
    }
`;


export const sLinkTag = css`
    background: #ebebeb;
    text-decoration: none;
    border: 0;
    border-radius: 3px;
    /*color: #555;*/
    color: #000;
    line-height: 1.625;
    padding: 8px 16px;
    &:hover,
    &:focus {
        color: #222;
        background: #dfdfdf;
        border: 0;
    }
`

/*---------------------------------------------------*/

/*-------------- For Tags page styled ---------------*/

export const GridTags = styled.div`
    /* Grid Fallback */
    display: flex;
    flex-wrap: wrap;
      
    /* Supports Grid */
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-auto-rows: minmax(75px, auto);
    grid-gap: 1em;
    margin: 50px 0;

    /* If Grid is supported, remove the margin we set for the fallback */
    @supports (display: grid) {
        .module {
            margin: 0;
        }
    }
`

export const sTagLink = css`
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 5px; /* 5px rounded corners */
  
    /* Demo-Specific Styles */
    background: #ebebeb;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 75px;
    color: #555;
      
    /* Flex Fallback */
    margin-left: 5px;
    margin-right: 5px;
    flex: 1 1 200px;
    
    &:hover {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        color: #000;
    }
`
/*---------------------------------------------------*/


export const Languages = styled.ul`

    li {
        display: inline-block;
        margin: 8px 0;
        margin-right: 1rem;
        font-weight: bold;
        text-align: center;

        a {
            color: #B30000;

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }
`

export const Center = styled.div`
    text-align: center;
`

export const LicenseStyled = styled.div`
    text-align: center;
    background-color: #202a36;
`
/*---------------------------------------------------*/

export const SelectLanguage = styled.select`
    background: transparent;
    padding: 5px;
    /*color: #d65947;*/
    color: #B30000;
    margin: auto 2px;
    font-weight: bold;

    &:focus { 
        outline: none;
    }

    @media screen and (max-width: ${respMobile}) {
        color: white;
        font-weight: normal;
    }
`

export const sLink = css`
    color: #B30000;
    font-weight: bold;
    &:hover, 
    &:focus {
        text-decoration: underline;
    }
`

export const ImgPostDescription = styled.img`
    width: 970px;
    height: 250px;
    object-fit: cover;
`